import {
  useEffect,
  useMemo,
  useState
} from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";

import { Button, notification, Spin } from "antd";
import {
  teamAnnouncementDetailGetById,
  updateViewTeamAnnouncement,
  reset,
  updateAccess,
} from "./redux/slice";
//import Icons from "../../../../../../components/Icons";
import NotesList from "../../components/listNotes";
import moment from "moment";
import StatusChangesHistory from "../../modals/statusChangesHistory";
import { openStatusChangesHistory, dashboarNotesListSearch } from "../../.config/redux/actions";
import { useSecurity, useStatusLeadColor } from "../../../../../../config/hooks";
import { DinamicFormByStep } from "../../modals/dinamicFormByStep";
//permissions
import { P_TEAM_LEADS_NOTES, P_TEAM_LEADS_UPDATE_ANNOUNCEMENT_STATUS, P_TEAM_LEADS_STATUS_COLUMN } from "../../../../../../config/helpers/permissionsHash";
//import { getCatalog } from "../../../../../.config/redux/actions";
//permissions end

const TeamAnnouncementDetailView = () => {
  let { id } = useParams();
  const dispatch = useDispatch();
  const { messages } = useIntl();
  const navigate = useNavigate();

  const [announcementStatusList, getDetailStatusColor] = useStatusLeadColor();

  const { user } = useSelector((state) => state.authRedux);
  const { data, error, result, resultError, updatingAccess, loading } = useSelector(
    (state) => state.teamAnnouncementDetailRedux
  );

  const [hasAccess, setHasAccess] = useState({})

  useEffect(() => {
    dispatch(teamAnnouncementDetailGetById({id}));
    if (!user.isAdmin)
      dispatch(updateViewTeamAnnouncement({ id, viewType: "View" }));

    return () => {
      dispatch(reset());
    };
  }, [id]);

  useEffect(() => {
    if (result) {
      notification.success({ message: messages["saveSuccessfully"] })
      dispatch(reset({ result: null }))
      dispatch(teamAnnouncementDetailGetById({id}));
    }

    if (resultError) {
      notification.error({ message: messages["saveError"], description: 'Si è verificato un errore' })
      dispatch(reset({ resultError: null }))
    }

  }, [result, resultError]);

  useEffect(() => {
    if (error) {
      error == 'unAuthorized' ? navigate("/unauthorized") : navigate("/error");
    }
  }, [error]);

  // Implementacion de permisos 
  const pShowStatusCol = useSecurity(P_TEAM_LEADS_STATUS_COLUMN);
  const pChangeStatus = useSecurity(P_TEAM_LEADS_UPDATE_ANNOUNCEMENT_STATUS);
  const pShowNotes = useSecurity(P_TEAM_LEADS_NOTES);

  const accessUsers = useMemo(() => {
    if(!data || !data?.restrictionAccess)
      return []

    let resultUsers = [];
    const maxUsers = Math.max(data?.restrictionAccess?.agents.length, data?.restrictionAccess?.areaManagers.length, data?.restrictionAccess?.affiliatedPartners.length);
    for (let index = 0; index < maxUsers; index++) {
      const am = data?.restrictionAccess?.areaManagers[index];
      const ag = data?.restrictionAccess?.agents[index];
      const ap = data?.restrictionAccess?.affiliatedPartners[index];
      const _hasAccess = {}
      if (am) {
        _hasAccess[am.userId] = am.hasAccess != 0;
      }
      if (ag) {
        _hasAccess[ag.userId] = ag.hasAccess != 0;
      }
      if (ap) {
        _hasAccess[ap.userId] = ap.hasAccess != 0;
      }
      setHasAccess((prev) => ({...prev, ..._hasAccess}));
      resultUsers = [...resultUsers, am, ag, ap]
    }
    return resultUsers
  }, [data])

  const statusAlert = useMemo(() => {
    if (pShowStatusCol && data?.status) {
      const _status = getDetailStatusColor(data?.status)

      return (
        <div
          onClick={() =>
            dispatch(
              openStatusChangesHistory({ companyAnnouncementId: data?.id, typeAnnouncement: 'TEAM' })
            )
          }
          style={{ cursor: "pointer", backgroundColor: _status.backgroundColor, color: _status.textColor }}
          className={`alert`}
          role="alert"
        >
          <h6 className="alert-heading mb-1">
            {`${data?.status ? _status?.name : 'avvia il cambiamento di stato'}`}
          </h6>
          <span>
            {data?.lastStatus?.updatedOn &&
              moment(data.lastStatus.updatedOn).format("DD/MM/yyyy HH:mm a")}
          </span>
        </div>
      );
    }
    return <></>;
  },[announcementStatusList, data, getDetailStatusColor, pShowStatusCol]);

  const handleAccess = (userAccess) => (e) => {
    dispatch(updateAccess({id: data.id, userId: userAccess.userId, hasAccess: e.target.checked}));
    setHasAccess((prev) => ({...prev, [userAccess.userId]: !prev[userAccess.userId]}));
  }

  return (
    <div className="container-fluid flex-grow-1 container-p-y">
      {statusAlert}
      <Spin spinning={loading}>
        <div className="card mb-4">
          <h5 className="card-header">{messages["dashboardDetail_title"]}</h5>
          <div className="card-body">
            <div className="row">
              <h6 className="card-subtitle mb-2">
                {messages["dashboardDetail_title1"]}:
              </h6>
              {data?.announcement?.description && (
                <div className="col-12 col-xl-12">
                  <h6>{data?.announcement?.description}</h6>
                </div>
              )}
              {data?.announcement?.product && (
                <div className="col-12 col-xl-4">
                  <small className="text-muted">
                    {messages["dashboardDetail_1"]}
                  </small>
                  <h6>{data?.announcement?.product}</h6>
                </div>
              )}
              <div className="col-12 col-xl-4">
                <small className="text-muted">
                  {messages["dashboardDetail_2"]}
                </small>
                <h6>
                  {data?.announcement?.max_price ||
                    messages["dashboardDetail_notSpecified"]}
                </h6>
              </div>
              {data?.announcement?.definition && (
                <div className="col-12 col-xl-4">
                  <small className="text-muted">
                    {messages["dashboardDetail_7"]}
                  </small>
                  <h6>{data?.announcement?.definition}</h6>
                </div>
              )}
              {data?.announcement?.id && (
                <div className="col-12 col-xl-4">
                  <small className="text-muted">
                    {messages["dashboardDetail_9"]}
                  </small>
                  <h6>{data?.announcement?.id}</h6>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="card mb-4">
          <h5 className="card-header">{messages["dashboardDetail_title2"]}</h5>
          <div className="card-body">
            {data && (
              <div className="row">
                <div className="col-12 col-xl-6">
                  <small className="text-muted">
                    {messages["dashboardDetail_author1"]}
                  </small>
                  <h6>
                    {data?.announcement?.name} {data?.announcement?.surname}
                  </h6>
                </div>
                <div className="col-12 col-xl-6">
                  <small className="text-muted">
                    {messages["dashboardDetail_author2"]}
                  </small>
                  <h6>{data?.announcement?.province_name}</h6>
                </div>
                <div className="col-12">
                  <small className="text-muted">
                    {messages["dashboardDetail_author3"]}
                  </small>
                  <h6>{data?.announcement?.comuna_name}</h6>
                </div>
                <div className="col-12 col-xl-6">
                  <small className="text-muted">
                    {messages["dashboardDetail_author4"]}
                  </small>
                  <h6>{data?.announcement?.phone}</h6>
                </div>
                <div className="col-12 col-xl-6">
                  <small className="text-muted">
                    {messages["dashboardDetail_author5"]}
                  </small>
                  <h6>{data?.announcement?.email}</h6>
                </div>
                <div className="col-12 col-xl-6">
                  <Button
                    icon={<i className="tf-icons bx bxl-whatsapp"></i>}
                    onClick={() => {
                      if (!user.isAdmin) {
                        dispatch(
                          updateViewTeamAnnouncement({
                            id,
                            viewType: "Whatsapp",
                          })
                        );
                      }
                      window.open(
                        `https://wa.me/39${data?.announcement?.phone}?text=${data?.announcement?.product}`,
                        "_blank",
                        "noreferrer"
                      );
                    }}
                  >
                    {messages["dashboardDetail_whatsapp"]}
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </Spin>
      {user?.isAdmin && <div className="card mb-4">
        <Spin spinning={updatingAccess || loading}>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table">
                <thead className="border-top">
                  <tr key="head">
                    <th className="text-nowrap text-center">Area Manager</th>
                    <th className="text-nowrap text-center">Agenti</th>
                    <th className="text-nowrap text-center">Partner Affiliati</th>
                  </tr>
                </thead>
                <tbody>
                  {accessUsers.map(
                    (user, i) => (i % 3 === 0) ? 
                    <tr key={"row" + i}>
                      <td key={"user" + i}>
                        {accessUsers[i] ? <div className="form-check d-flex">
                          <label>{accessUsers[i].fullName} <input className="form-check-input" type="checkbox" id="defaultCheck1" onChange={handleAccess(accessUsers[i])} checked={hasAccess[accessUsers[i].userId]}/></label>
                        </div> : <></>}
                      </td>
                      <td key={"user" + (i + 1)}>
                        {accessUsers[i + 1] ? <div className="form-check d-flex">
                          <label>{accessUsers[i + 1].fullName} <input className="form-check-input" type="checkbox" id="defaultCheck1" onChange={handleAccess(accessUsers[i + 1])} checked={hasAccess[accessUsers[i + 1].userId]}/></label>
                        </div> : <></>}
                      </td>
                      <td key={"user" + (i + 2)}>
                        {accessUsers[i + 2] ? <div className="form-check d-flex">
                          <label>{accessUsers[i + 2].company.name} <input className="form-check-input" type="checkbox" id="defaultCheck1" onChange={handleAccess(accessUsers[i + 2])} checked={hasAccess[accessUsers[i + 2].userId]}/></label>
                        </div>: <></>}
                      </td>
                    </tr> 
                  : null)}
                </tbody>
              </table>
            </div>
          </div>
        </Spin>
      </div>}
      <StatusChangesHistory
        onChangeStatus={() => {
          dispatch(
            teamAnnouncementDetailGetById({
              id,
            })
          );
        }}
        refresh={() => { dispatch(dashboarNotesListSearch({ companyAnnouncementId: data?.id, typeAnnouncement: 'TEAM', limit: 10, offset: 0 })) }}
      />
      {pShowNotes && (
        <NotesList typeAnnouncement={'TEAM'} roleName={'TEAM'} companyAnnouncementId={data?.id} additionalButtons={[
          (pChangeStatus ? <button
            key={0}
            className="btn btn-primary me-sm-3 me-1"
            onClick={() => {
              dispatch(openStatusChangesHistory({ companyAnnouncementId: data?.id, typeAnnouncement: 'TEAM' }))
            }}
          >
            {messages["dashboardList_changeStatus"]}
          </button> : <></>)
        ]} />
      )}
      <DinamicFormByStep userAnnouncementId={data?.id}  typeAnnouncement={'TEAM'} />
    </div>
  );
};

export default TeamAnnouncementDetailView;
